module.exports = __webpack_public_path__ + "img/mouse_cursor_exhibitor.dcc6f080.png";